const CONSTANTS = {
  baseUrl: "https://thk-true-stories.herokuapp.com/"
}
export default CONSTANTS
